/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineEnergy.vue?vue&type=template&id=2a062e92&scoped=true"
import script from "./popMineEnergy.vue?vue&type=script&lang=js"
export * from "./popMineEnergy.vue?vue&type=script&lang=js"
import style0 from "./popMineEnergy.vue?vue&type=style&index=0&id=2a062e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a062e92",
  null
  
)

export default component.exports